import React, { useEffect, useState } from "react";
import "./Footer.css";
//import Category from "./Category";
import HorizontalFooter from "./HorizontalFooter";

const Footer = function (props) {
    const [itemsObj,setItemsObj]= useState({});
    const [categoryArray,setCategoryArray]= useState([]);
    useEffect(()=>{
        //for push down the title in mobile and inner page...
        if(window.outerWidth<769 && document.getElementsByClassName('dvCenterZoneInnerP').length>0 && document.getElementsByClassName('matal-breadcrumb').length >0){
        //  check if there no image
        let breadcrumb= document.getElementsByClassName('matal-breadcrumb')[0];
        let divCenterZoneInner =  document.getElementsByClassName('dvCenterZoneInnerP')[0];
        
                if(!breadcrumb.nextElementSibling && !breadcrumb.previousElementSibling){
                    let marginTopHeight = breadcrumb.clientHeight /2 ;
                        divCenterZoneInner.style.marginTop = marginTopHeight+"px";
                }
        }

    },[]);
    useEffect(()=>{
        
        if(!!props.items && props.items.length>0){
            let tempObj =   props.items.reduce(function (temp, item) {
             
                if (!temp[item.MODFooterCategory]) temp[item.MODFooterCategory] = []
                temp[item.MODFooterCategory].push(item);
                return temp;
            }, Object.create(null));
            setItemsObj(tempObj);
   
        }
    },[props.items]);
    const NavigationUrl =(tempUrl)=>{
        if(!!tempUrl){
            setTimeout(()=>{
            window.location.href =tempUrl; 
            },200);
        }
    };
    let btnNav =
        Object.keys(itemsObj).map((key) => {

          return  itemsObj[key].map((item,idx)=>{
            
              if(item.MODFooterCategory.indexOf('כפתור')>-1){
                  return   (
                  <button key={item.ID} 
                  onClick={()=>{NavigationUrl(item.MODFooterLink.NavigateUrl)}}
                   className="contact-us-but  btn btn-outline-secondary">
                  {item.LinkTitle}
                  
                </button>)
              }

              if((!('MODFooterIsShow' in item) || !!item.MODFooterIsShow) && item.MODFooterCategory.indexOf('כפתור')===-1)
                return  <HorizontalFooter key={item.ID} item={item}  NavigationUrl={()=>{NavigationUrl(item.MODFooterLink.NavigateUrl)}}  />
            });
    });
   
    return (
        <div className="row footerCont no-gutters horizontal-footer ">
                {btnNav}

                <div>
                    {/* <i className="glyphicon glyphicon-chevron-down"></i>*/}
                    {/* <i className="fa fa-chevron-down"></i>  */}
                     </div> 
        </div>
    );
}
export default Footer;